function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "27",
  height: "22",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  fill: "#000",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.485 10.492l5.904-9.53 5.905 9.53zM.468 21.826l5.905-9.529 5.904 9.53zM14.555 21.826l5.907-9.529 5.902 9.53z"
})));